<template>
    <v-container>
      <v-row justify="center">
        <v-col cols="12" md="10" lg="8">
          <v-card class="rounded-xl elevation-4">
            <v-card-title class="primary white--text">
              <v-icon large left color="white">mdi-account-plus</v-icon>
              <span class="headline font-weight-bold">Adicionar Exames ao Técnico</span>
            </v-card-title>

            <v-divider class="mb-4"></v-divider>
            <v-card-text>
              <v-text-field
                v-model="nomeMedico"
                label="Nome do Técnico"
                disabled
                outlined
                prepend-icon="mdi-account"
                class="mb-6"
              ></v-text-field>

              <v-progress-circular
                v-if="mostrarLoading"
                indeterminate
                color="primary"
                size="64"
                width="6"
                class="d-block mx-auto my-8"
              ></v-progress-circular>

              <!-- Formulário de Seleção de Serviço -->
              <v-form
                v-if="mostrarListaServicos"
                ref="formServico"
                v-model="validServico"
                @submit.prevent="retornarExames"
              >
                <v-autocomplete
                  v-model="servicoSelecionado"
                  :items="servicosMedico"
                  item-text="nomeEspecialidade"
                  return-object
                  label="Serviço"
                  outlined
                  :rules="regrasServico"
                  no-data-text="Nenhum serviço disponível"
                  prepend-icon="mdi-briefcase-search"
                  class="mb-6"
                ></v-autocomplete>

                <v-alert
                  v-model="erroProcessamento"
                  color="error"
                  icon="mdi-alert-circle"
                  dense
                  outlined
                  dismissible
                  class="mb-4"
                >
                  Ocorreu um erro ao processar sua solicitação
                </v-alert>

                <v-card-actions class="px-0">
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    large
                    rounded
                    depressed
                    type="submit"
                    :disabled="!validServico"
                    :loading="carregandoServicos"
                    class="px-6"
                  >
                    <v-icon left>mdi-arrow-right</v-icon>
                    Próximo
                  </v-btn>

                  <v-btn
                    to="/listaTecnicosUnidade"
                    large
                    outlined
                    rounded
                    color="grey darken-1"
                    class="ml-2"
                  >
                    <v-icon left>mdi-arrow-left</v-icon>
                    Voltar
                  </v-btn>
                </v-card-actions>
              </v-form>

              <!-- Formulário de Seleção de Exames -->
              <v-form
                v-if="mostrarListaExames"
                ref="formExames"
                v-model="validExames"
                @submit.prevent="cadastrarExameMedico"
              >
                <v-autocomplete
                  v-model="listaExamesDoMedico"
                  :items="listaExamesRetornados"
                  item-text="nomeExame"
                  item-value="idExame"
                  label="Exames"
                  outlined
                  chips
                  multiple
                  :rules="regrasExames"
                  no-data-text="Nenhum exame disponível"
                  prepend-icon="mdi-clipboard-list"
                  class="mb-6"
                >
                  <template v-slot:prepend-item>
                    <v-list-item ripple @click="toggleSelecaoExames">
                      <v-list-item-action>
                        <v-icon :color="listaExamesDoMedico.length > 0 ? 'indigo darken-4' : ''">
                          {{ iconeSelecao }}
                        </v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>{{ textoSelecao }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                  </template>
                </v-autocomplete>

                <v-checkbox
                  v-model="checkbox"
                  :rules="[v => !!v || 'Você deve concordar para continuar']"
                  label="Confirmo que as informações estão corretas"
                  required
                  class="mt-0"
                ></v-checkbox>

                <v-alert
                  v-model="erroProcessamento"
                  color="error"
                  icon="mdi-alert-circle"
                  dense
                  outlined
                  dismissible
                  class="mb-4"
                >
                  Ocorreu um erro ao processar sua solicitação
                </v-alert>

                <v-alert
                  v-model="sucessoProcessamento"
                  color="success"
                  icon="mdi-check-circle"
                  dense
                  outlined
                  dismissible
                  class="mb-4"
                >
                  Exames atualizados com sucesso!
                </v-alert>

                <v-card-actions class="px-0">
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    large
                    rounded
                    depressed
                    type="submit"
                    :disabled="!validExames"
                    :loading="carregandoExames"
                    class="px-6"
                  >
                    <v-icon left>mdi-content-save</v-icon>
                    Salvar Alterações
                  </v-btn>

                  <v-btn
                    large
                    outlined
                    rounded
                    color="grey darken-1"
                    class="ml-2"
                    @click="voltarParaServicos"
                  >
                    <v-icon left>mdi-arrow-left</v-icon>
                    Voltar
                  </v-btn>
                </v-card-actions>
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
import administradorUnidadeService from '../../../services/administradorUnidade.service'

export default {
  name: 'AdicionarExamesTecnico',
  data () {
    return {
      // Estados de UI
      mostrarLoading: false,
      mostrarListaServicos: true,
      mostrarListaExames: false,
      carregandoServicos: false,
      carregandoExames: false,

      // Validação de formulários
      validServico: false,
      validExames: false,
      checkbox: false,

      // Dados do técnico
      idMedico: '',
      nomeMedico: '',
      user: null,
      servicoSelecionado: null,

      // Listas de dados
      servicosMedico: [],
      servicosUnidade: [],
      listaExamesRetornados: [],
      listaExamesDoMedico: [],
      listaExamesDoMedicoInicial: [],

      // Feedback
      erroProcessamento: false,
      sucessoProcessamento: false,

      // Regras de validação
      regrasServico: [
        v => !!v || 'Selecione um serviço para continuar'
      ],
      regrasExames: [
        v => (v && v.length > 0) || 'Selecione pelo menos um exame'
      ]
    }
  },
  computed: {
    todosExamesSelecionados () {
      return this.listaExamesDoMedico.length === this.listaExamesRetornados.length
    },
    algunsExamesSelecionados () {
      return this.listaExamesDoMedico.length > 0 && !this.todosExamesSelecionados
    },
    textoSelecao () {
      if (this.todosExamesSelecionados) return 'Desmarcar todos'
      if (this.algunsExamesSelecionados) return 'Selecionar todos'
      return 'Selecionar todos'
    },
    iconeSelecao () {
      if (this.todosExamesSelecionados) return 'mdi-checkbox-marked'
      if (this.algunsExamesSelecionados) return 'mdi-checkbox-intermediate'
      return 'mdi-checkbox-blank-outline'
    }
  },
  async mounted () {
    if (!this.$route.params.item) {
      this.$router.push('/listaTecnicosUnidade')
      return
    }

    this.user = this.$store.getters.usuario
    this.idMedico = this.$route.params.item.idMedico
    this.nomeMedico = this.$route.params.item.nome

    await Promise.all([
      this.retornarServicosMedico(),
      this.retornarServicosUnidade()
    ])
  },
  methods: {
    toggleSelecaoExames () {
      this.$nextTick(() => {
        if (this.todosExamesSelecionados) {
          this.listaExamesDoMedico = []
        } else {
          this.listaExamesDoMedico = this.listaExamesRetornados.map(e => e.idExame)
        }
      })
    },

    voltarParaServicos () {
      this.mostrarListaServicos = true
      this.mostrarListaExames = false
      this.listaExamesRetornados = []
      this.listaExamesDoMedico = []
      this.sucessoProcessamento = false
    },

    async retornarServicosUnidade () {
      try {
        const response = await administradorUnidadeService.administradorUnidade
          .retornarServicosUnidade(this.user.idUnidade)
        this.servicosUnidade = response.data
      } catch (error) {
        console.error('Erro ao buscar serviços da unidade:', error)
        this.erroProcessamento = true
      }
    },

    async retornarServicosMedico () {
      try {
        const response = await administradorUnidadeService.administradorUnidade
          .retornarServicosMedico(this.idMedico)
        this.servicosMedico = response.data
      } catch (error) {
        console.error('Erro ao buscar serviços do técnico:', error)
        this.erroProcessamento = true
      }
    },

    async retornarExames () {
      if (!this.$refs.formServico.validate()) return

      this.carregandoServicos = true
      this.erroProcessamento = false

      try {
        const response = await administradorUnidadeService.administradorUnidade
          .retornarExames(this.servicoSelecionado.idExameEspecialidade)

        this.listaExamesRetornados = response.data
        await this.retornarExamesMedico()

        this.mostrarListaServicos = false
        this.mostrarListaExames = true
      } catch (error) {
        console.error('Erro ao buscar exames:', error)
        this.erroProcessamento = true
      } finally {
        this.carregandoServicos = false
      }
    },

    async retornarExamesMedico () {
      try {
        const response = await administradorUnidadeService.administradorUnidade
          .retornarExamesMedico(this.servicoSelecionado.idServico, this.idMedico)

        this.listaExamesDoMedico = response.data.map(e => e.idExame)
        this.listaExamesDoMedicoInicial = [...this.listaExamesDoMedico]
      } catch (error) {
        console.error('Erro ao buscar exames do técnico:', error)
        this.erroProcessamento = true
      }
    },

    async cadastrarExameMedico () {
      if (!this.$refs.formExames.validate()) return

      this.carregandoExames = true
      this.erroProcessamento = false
      this.sucessoProcessamento = false

      try {
        // Identificar exames adicionados e removidos
        const examesAdicionados = this.listaExamesDoMedico
          .filter(id => !this.listaExamesDoMedicoInicial.includes(id))
          .map(id => ({ idExame: id, status: 1 }))

        const examesRemovidos = this.listaExamesDoMedicoInicial
          .filter(id => !this.listaExamesDoMedico.includes(id))
          .map(id => ({ idExame: id, status: 0 }))

        const examesParaAtualizar = [...examesAdicionados, ...examesRemovidos]

        if (examesParaAtualizar.length === 0) {
          this.sucessoProcessamento = true
          setTimeout(() => this.$router.push('/listaTecnicosUnidade'), 1500)
          return
        }

        const response = await administradorUnidadeService.administradorUnidade
          .cadastrarExameMedico(
            this.idMedico,
            this.servicoSelecionado.idMedicoServico,
            examesParaAtualizar,
            this.servicoSelecionado.idServico
          )

        if (response.data === 'erro' || response.data === 'acessoNegado' || response.data === false) {
          this.erroProcessamento = true
        } else {
          this.sucessoProcessamento = true
          setTimeout(() => this.$router.push('/listaTecnicosUnidade'), 1500)
        }
      } catch (error) {
        console.error('Erro ao atualizar exames:', error)
        this.erroProcessamento = true
      } finally {
        this.carregandoExames = false
      }
    }
  }
}
</script>

<style scoped>
.rounded-xl {
  border-radius: 16px !important;
}

.v-card__title {
  border-top-left-radius: 16px !important;
  border-top-right-radius: 16px !important;
}

.v-chip {
  margin: 2px;
}

.v-btn {
  letter-spacing: normal;
  text-transform: none;
}

.v-btn--disabled {
  opacity: 0.6;
}

.v-progress-circular {
  z-index: 1;
}
</style>
